import React from "react";

import MaterialTable, { MTableToolbar } from "material-table";

import { OCCUPATION_LIST } from "../../../../scripts/const";

export default function OccupationList() {
  const getColumns = () => {
    return [
      {
        title: "Code",
        field: "code",
        type: "numeric",
        width: "20%",
      },
      {
        title: "Title",
        field: "title",
      },
    ];
  };

  const [data] = React.useState(OCCUPATION_LIST);

  return (
    <MaterialTable
      title="Occupation List"
      columns={getColumns()}
      data={data}
      options={{
        exportButton: true,
        pageSize: 50,
        pageSizeOptions: [50, 100, 200, 500, 1410],
        headerStyle: {
          backgroundColor: "#0077c2",
          color: "#FFF",
        },
        sorting: true,
      }}
      components={{
        Toolbar: (props) => (
          <div>
            <MTableToolbar {...props} />
            <h4
              style={{
                marginLeft: "20px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              ANZSCO - Australian and New Zealand Standard Classification of
              Occupations, 2021 Australian Update
            </h4>
            <div
              style={{
                marginLeft: "20px",
                paddingTop: "0px",
                marginTop: "0px",
              }}
            >
              Released at 11:30am (Canberra time) 23 November 2021
            </div>
          </div>
        ),
      }}
    />
  );
}
